.sn-call-to-action-type-1 {
  .call-to-action-type-2__content {
    overflow: hidden;
    border: 0;
    border-radius: map-get($border-radii, lg);
    background: $color-brand-primary-darkest;
    color: $color-neutral-white;

    > .me-row {
      margin-right: 0;
      margin-left: 0;
    }
  }

  .me-button--secondary,
  .me-button--primary {
    padding: map-get($spacings, sm) map-get($spacings, 2xl);
  }

  .call-to-action-type-2__intro {
    text-align: center;

    &-inner {
      padding: map-get($spacings, 4xl) map-get($spacings, 2xl);

      @include above($breakpoint-desktop-md) {
        padding: map-get($spacings, 6xl) 0 map-get($spacings, 6xl) map-get($spacings, 5xl);
        text-align: left;
      }
    }

    .me-text--label {
      display: block;
      margin-bottom: map-get($spacings, md);
      text-transform: uppercase;
      letter-spacing: 3px;
      font-size: map-get($font-sizes, xs);
      font-weight: map-get($font-weights, bold);
    }

    .me-heading {
      margin-bottom: map-get($spacings, 4xl);
    }

    .call-to-action-type-2 {
      .call-to-action-type-2__content {
        overflow: hidden;
        border: 0;
        border-radius: map-get($border-radii, lg);
        background: $color-brand-primary-darkest;
      }

      .call-to-action-type-2__intro {
        color: $text-color-alternate;
      }
    }

  }

  // Desktop: remove bottom margin from columns inside actions row
  @include desktop-lg {
    .call-to-action-type-2__actions.me-row > .me-column {
      margin-bottom: 0;
    }
  }

  // Tablet (768px–960px): override grid → flex, buttons in one row, centered
  @include between($breakpoint-desktop, $breakpoint-desktop-md - 1px) {
    .call-to-action-type-2__actions.me-row {
      display: flex;
      justify-content: center;
      width: auto;
      margin-left: 0;
      margin-right: 0;
      gap: var(--spacing-md);

      > me-column {
        padding: 0;

        .me-button {
          width: auto;
        }
      }
    }
  }

  // Mobile (below 768px): keep grid stacked, center the container
  @include below-desktop {
    .call-to-action-type-2__actions.me-row {
      margin-left: auto;
      margin-right: auto;
    }

    .call-to-action-type-2__intro.me-column {
      margin-bottom: 0;
    }
  }

  .call-to-action-type-2__media {
    display: none;

    @include above($breakpoint-desktop-md) {
      display: block;
    }

    &-inner {
      padding: map-get($spacings, 3xl);

      @include above($breakpoint-desktop-md) {
        padding: map-get($spacings, 6xl) map-get($spacings, 5xl) map-get($spacings, 6xl) 0;
      }
    }

    .cta-list {
      display: flex;
      flex-direction: column;
      gap: map-get($spacings, 3xl);

      .cta-list__item {
        display: flex;
        align-items: center;
        gap: map-get($spacings, xl);

        .cta-list__logo img {
          min-width: 44px;
        }
      }

      .cta-list__description {
        font-family: Graphik, Arial, sans-serif;
        font-size: map-get($font-sizes, md);
        line-height: map-get($line-heights, md);

        @include desktop-lg {
          font-size: map-get($font-sizes, lg);
          line-height: map-get($line-heights, lg);
        }
      }
    }
  }
}
